import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import { BONUS_DASHBOARD_CURRENT, BONUS_DASHBOARD_HISTORY } from '@/routing/routes';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';

function BonusDashboardTabs({ active }) {
    const scrollElementRef = useHeaderTabsScroll();
    return (
        <HeaderTabsContainer>
            <TabButton
                route={BONUS_DASHBOARD_CURRENT}
                i18nCode="dashboard.bonus"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={BONUS_DASHBOARD_HISTORY}
                i18nCode="dashboard.history"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
        </HeaderTabsContainer>
    );
}

export default BonusDashboardTabs;
